exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".template-preview[data-v-9cd1545a] {\n  width: 490px;\n  height: 635px;\n  border: 0;\n  overflow-x: hidden;\n}\n", ""]);

